import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Modal from 'antd/lib/modal';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import { Row, Col } from 'react-flexbox-grid';
import {
  dividingPaymentRequest,
} from '../ducks';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import rules from '../../../common/rules/rules';
import message from 'antd/lib/message';

const { Item } = Form;

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      dividingPayment: dividingPaymentRequest,
    },
    dispatch
  ),
});

@translate()
@Form.create()
@connect(undefined,mapDispatchToProps)
export default class PaymentDivisionModal extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    payment: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  onClose = e => {
    this.props.onClose && this.props.onClose(e);
  };

  generate = e => {
    const { form } = this.props;
    const numberOfPayments = form.getFieldValue('numberOfDividedPaymnets');
    setTimeout(() => {
      form.setFieldsValue({ paymentKeys: [...Array(parseInt(numberOfPayments)).keys()] });
    });
    
  }


  handleConfirm = () => {
    const { payment, actions, form, t } = this.props;
    
    form.validateFields((err, values) => {
      if (!err) {
        const data = values.dividedPayments.map(d=> {
          return {
            amount: parseFloat(d.amount.replace(',','.')),
            variableSymbol: d.variableSymbol
          };
        });
        const paymentId = payment.id;
        const sumAmount = data.map(d => d.amount).reduce((total, amount) => total + amount);

        if (sumAmount.toFixed(2) !== parseFloat(payment.amount).toFixed(2)){
          message.error(
            t('Súčet súm musí byť zhodný so sumou platby.'),
            5
          );
        } else {
          actions.dividingPayment({ paymentId , data });
          setTimeout(() => {
            form.setFieldsValue({ paymentKeys: [] });
          });
          this.props.onClose();
        }
      }
    });
  }

  render() {
    const { t, form } = this.props;

    const { getFieldDecorator, getFieldValue } = form;

    if (!this.props.show) {
      return null;
    }

    // define helper for dynamic phones
    getFieldDecorator('paymentKeys', { initialValue: [] });

    const paymentKeys = getFieldValue('paymentKeys');

    return <Modal
            title={t('Rozdelenie platby')}
            visible
            onCancel={this.onClose}
            footer={
              paymentKeys.length === 0 ?
              [ 
                <Button type="primary" onClick={this.generate}>
                  {t('Potvrdiť')}
                </Button>,
                <Button key="cancel" onClick={this.onClose}>
                  {t('Zavrieť')}
                </Button>         
              ] : [
                <Button type="primary" onClick={this.handleConfirm}>
                  {t('Potvrdiť')}
                </Button> ,
                <Button key="cancel" onClick={this.onClose}>
                  {t('Zavrieť')}
                </Button> 
              ]
            }
            width={600}
          >
            <div>
            { paymentKeys.length === 0 && <Form>
                <span>{t('Zadajte počet na koľko si prajete rozdeliť platbu.')}</span>
                <div className="padded">
                  <Item label={t('Počet')}>
                    {
                      getFieldDecorator('numberOfDividedPaymnets', { 
                        rules: [
                          ...rules.required,
                          rules.number,
                          rules.moreThanValue(1),
                        ]
                      })(
                        <Input size="default" type="number"/>
                      )
                    }
                  </Item>
                </div>
              </Form>
            }
            { paymentKeys.length > 0 && <Form>
                { paymentKeys.map(key =>
                    <Row>
                      <Col style={{ marginRight: 10}}>
                        <Item label={t('Suma')}>
                        {
                          getFieldDecorator(`dividedPayments[${key}].amount`, { 
                            rules: [
                              ...rules.required,
                              rules.number,
                              rules.positiveNumber,
                            ]
                          })(<Input size="default"/>)
                        }
                        </Item>
                      </Col>
                      <Col >
                        <Item  label={t('Variabilný symbol')}>
                        {
                          getFieldDecorator(`dividedPayments[${key}].variableSymbol`, { 
                            rules: rules.required
                          })(<Input size="default"/>)
                        }
                        </Item>
                      </Col>
                    </Row>
                    
                ) }
              </Form> 
            }
            </div>
          </Modal>
  }
}


// WEBPACK FOOTER //
// ./src/features/payment-management/components/PaymentDivisionModal.js